<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">{{ routeLabel }}</h3>
        <div class="text-xs-right d-flex align-center">
          <v-btn
              color="blue darken-3"
              dark
              small
              class="mr-2"
              @click="handleExport('country')"
              :loading="exporting && exportType === 'country'"
          >
            <v-icon left small>download</v-icon>
            Country Wise Export
          </v-btn>
          <v-btn
              color="blue darken-3"
              dark
              small
              class="mr-2"
              @click="handleExport('office')"
              :loading="exporting && exportType === 'office'"
          >
            <v-icon left small>download</v-icon>
            Office Wise Export
          </v-btn>
          <refresh-button :click-function="fetchData" />
        </div>
      </v-flex>

      <v-flex xs12>
        <v-card>
          <!-- Filters Row -->
          <v-layout class="py-2 px-3" row wrap>
            <v-flex xs12 sm4 class="pr-2">
              <v-flex class="d-flex align-center">
                <custom-date-range-picker @change="fetchData"
                                          v-model="filters.date_range"></custom-date-range-picker>
              </v-flex>
            </v-flex>
            <v-flex xs3>
              <v-autocomplete
                  :items="countries"
                  chips
                  clearable
                  deletable-chips
                  flat
                  hide-details
                  item-text="country_name"
                  item-value="id"
                  label="Country"
                  multiple
                  prepend-inner-icon="filter_list"
                  solo
                  v-model="filters.country"
                  @change="fetchData"
              ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm4>
              <v-autocomplete
                  :elevation="0"
                  flat
                  v-model="filters.office_id"
                  :items="offices"
                  item-text="name"
                  item-value="id"
                  label="Filter by office"
                  prepend-inner-icon="filter_list"
                  solo
                  hide-details
                  clearable
                  @change="fetchData"
              />
            </v-flex>
<!--            <v-flex class="pb-0" xs6>-->
<!--              <v-autocomplete-->
<!--                  :elevation="0"-->
<!--                  flat-->
<!--                  :items="office_types"-->
<!--                  hide-details-->
<!--                  prepend-inner-icon="filter_list"-->
<!--                  v-model="filters.office_type"-->
<!--                  @change="handleFilterChange"-->
<!--                  placeholder="Filter by office type"-->
<!--                  solo-->
<!--              >-->
<!--              </v-autocomplete>-->
<!--            </v-flex>-->
          </v-layout>

          <v-divider />

          <!-- Data Table -->
          <v-data-table
              :headers="headers"
              :items="rows"
              :loading="loading"
              :options.sync="pagination"
              :server-items-length="serverTotal"
              :footer-props="footerProps"
              item-key="id"
              style="cursor: pointer"
          >
            <template v-slot:item="{ item, index }">
              <tr>
                <td>{{ (pagination.page - 1) * pagination.itemsPerPage + index + 1 }}</td>
                <td @click="goToCountryWise(item)" style="cursor: pointer">{{ item.model_name }}</td>
                <td>{{ item.no_of_male_arrivals }}</td>
                <td>{{ item.no_of_female_arrivals }}</td>
                <td>{{ item.total_arrivals }}</td>
                <td>{{ item.no_of_male_departures }}</td>
                <td>{{ item.no_of_female_departures }}</td>
                <td>{{ item.total_departures }}</td>
                <td>{{ item.date_for }}</td>
              </tr>
            </template>
            <template v-slot:body.append>
              <tr class="grey lighten-2 font-weight-bold">
                <td>-</td>
                <td>Total</td>
                <td v-for="field in totalFields" :key="field">{{ totals[field] }}</td>
                <td>-</td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Export Dialog -->
    <v-dialog v-model="exportDialog" persistent width="500">
      <v-card>
        <v-toolbar color="blue darken-3" dark>
          <v-toolbar-title>Export Options</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="exportDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pt-4">
          <v-form ref="exportFormRef" v-model="exportValid" lazy-validation>
            <v-text-field
                v-model="exportName"
                label="Name"
                outlined
            />
            <v-text-field
                v-model="exportRows"
                :rules="[rules.required]"
                label="Number of rows to export *"
                type="number"
                outlined
            />
          </v-form>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
              color="red lighten-1"
              class="white--text"
              @click="exportDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
              color="blue darken-3"
              class="white--text"
              :loading="exporting"
              @click="handleExportClicked"
          >
            Export
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Http from "axios";
import { VERSIONED_API_URL } from "../../config/config";
import RefreshButton from "@/components/RefreshButton";
import CustomDateRangePicker from "../../components/CustomDateRangePicker.vue";
export default {
  name: "SummaryReportAd",

  components: { RefreshButton,CustomDateRangePicker },

  data() {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const yesterdayDate = yesterday.toISOString().split("T")[0];
    return {
      // table
      rows: [],
      loading: false,
      serverTotal: 0,

      // filters
      filters: {
        date_range: { start: yesterdayDate, end: yesterdayDate },
        country: [],
        office_id: null,
      },

      // date picker
      dateMenu: false,
      dateRangeValues: [yesterdayDate, yesterdayDate],

      // pagination
      pagination: {
        page: 1,
        itemsPerPage: 25,
        sortBy: ["created_at"],
        sortDesc: [true],
      },
      footerProps: {
        "items-per-page-options": [10, 25, 50, 100, {text: 'All', 'value': -1}],
      },

      // export
      exportDialog: false,
      exporting: false,
      exportValid: true,
      exportName: "",
      exportRows: 500,
      exportType: 'country',

      rules: {
        required: (v) => !!v || "This field is required",
      },

      totalFields: [
        "no_of_male_arrivals",
        "no_of_female_arrivals",
        "total_arrivals",
        "no_of_male_departures",
        "no_of_female_departures",
        "total_departures",
      ],

      headers: [
        { text: "S.N.",              value: "s_no",                      sortable: false },
        { text: "Country/Office",      value: "model_name",              sortable: false },
        { text: "Male Arrived",      value: "no_of_male_arrivals",     sortable: false },
        { text: "Female Arrived",    value: "no_of_female_arrivals",   sortable: false },
        { text: "Total Arrived",     value: "total_arrivals",          sortable: false },
        { text: "Male Departed",     value: "no_of_male_departures",   sortable: false },
        { text: "Female Departed",   value: "no_of_female_departures", sortable: false },
        { text: "Total Departed",    value: "total_departures",        sortable: false },
        { text: "Date For",          value: "date_for",                sortable: false },
      ],
    };
  },

  computed: {
    ...mapGetters({
      countries: "CountryList/all",
      offices:   "OfficeList/offices",
    }),

    routeLabel() {
      return (this.$route && this.$route.meta && this.$route.meta.label) || "Arrival/Departure Summary Report";
    },

    formattedDateRange() {
      const { start, end } = this.filters.date_range || {};
      if (start && end) return `${start} ~ ${end}`;
      if (start) return start;
      return "";
    },

    totals() {
      const result = {};
      this.totalFields.forEach((field) => (result[field] = 0));
      this.rows.forEach((row) => {
        this.totalFields.forEach((field) => {
          result[field] += parseInt(row[field]) || 0;
        });
      });
      return result;
    },
  },

  watch: {
    pagination: {
      deep: true,
      handler() {
        this.fetchData();
      },
    },
  },

  methods: {
    ...mapActions({
      fetchCountries: "CountryList/fetchCountries",
      fetchOffices:   "OfficeList/fetchData",
    }),

    buildParams() {
      const { page, itemsPerPage, sortBy, sortDesc } = this.pagination;
      const { start, end } = this.filters.date_range || this.dateRangeValues;

      const params = {
        page,
        per_page:   itemsPerPage,
        sort_by:    (sortBy && sortBy[0]) || "created_at",
        descending: (sortDesc && sortDesc[0] !== undefined ? sortDesc[0] : true),
        paginate:   true,
      };

      if (start) params.start_date = start;
      if (end)   params.end_date   = end;
      if ((this.filters.country && this.filters.country.length)) params.country   = this.filters.country;
      if (this.filters.office_id)       params.office_id = this.filters.office_id;

      return params;
    },

    fetchData() {
      this.loading = true;
      Http.get(`${VERSIONED_API_URL}/summary-report-data/ad`, { params: this.buildParams() })
          .then((res) => {
            const data    = res.data;
            this.rows        = (data.data !== undefined ? data.data : data);
            this.serverTotal = data.meta.total || data.total || this.rows.length;
          })
          .catch((err) => {
            console.error("Failed to fetch AD summary:", err);
          })
          .finally(() => {
            this.loading = false;
          });
    },

    onDateRangeChange(val) {
      if (val && val.length === 2) {
        const [a, b] = val.slice().sort();
        this.filters.date_range = { start: a, end: b };
        this.dateMenu = false;
        this.fetchData();
      }
    },

    handleExport(type = 'country') {
      this.exportType = type;
      this.exportDialog = true;
    },

    handleExportClicked() {
      if (!this.$refs.exportFormRef.validate()) return;
      this.exporting = true;

      const endpoint = this.exportType === 'office'
          ? `${VERSIONED_API_URL}/summary-report-data/ad/export-office`
          : `${VERSIONED_API_URL}/summary-report-data/ad/export`;

      Http.post(
          endpoint,
          { ...this.buildParams(), exportName: this.exportName, exportRows: this.exportRows },
      ).then((res) => {
        // console.log(res);
        // const url = res.data.url;
        // const link = document.createElement("a");
        // link.href = url;
        // link.download = `${this.exportName || "ad-summary"}.xlsx`;
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
        window.open(res.data.url, "_blank");
        this.exportDialog = false;
      })
          .catch((err) => {
            console.error("Export failed:", err);
          })
          .finally(() => {
            this.exporting = false;
          });
    },
    goToCountryWise(item) {
      const matchedCountry = this.countries.find(c => c.country_name === item.model_name);
      const matchedOffice = this.offices.find(c => c.name === item.model_name);
      console.log(matchedOffice)
      const route = this.$router.resolve({
        name: 'ArrivalDepartureReport',
        query: {
          start_date: item.date_for,
          end_date: item.date_for,
          country: matchedCountry ? [matchedCountry.id] : this.filters.country,
          offices: matchedOffice ? [matchedOffice.id] : this.filters.office_id,
        }
      });
      window.open(route.href, '_blank');
    },
  },

  mounted() {
    if (this.$store.state.CountryList && this.$store.state.CountryList.all && this.$store.state.CountryList.all.length === 0) {
      this.fetchCountries();
    }
    this.fetchOffices();
    this.fetchData();
  },
};
</script>

<style scoped>
.font-weight-bold td {
  font-weight: 700;
}
</style>